/**
 * SortableListContext
 *
 * Internal context for passing state from SortableList to SortableList.Item.
 * Handles disabled state and stable ID generation.
 */

import { createContext, useContext } from 'react';
import type { SortableListContextValue } from './SortableList.types';

/**
 * Context for SortableList internal state
 */
export const SortableListContext = createContext<SortableListContextValue | null>(null);

/**
 * Hook to access SortableList context
 * @throws Error if used outside of SortableList
 */
export function useSortableListContext(): SortableListContextValue {
  const context = useContext(SortableListContext);

  if (!context) {
    throw new Error(
      'SortableList.Item must be used within a SortableList component'
    );
  }

  return context;
}
